import axios from "axios";
import config from "./index.js";
import { getToken } from "@/utils/tokenStorage";
import apiErrorHandler from "@/utils/apiErrorHandler";
const BASE_URL = config.BASE_URL;

const apiClient = axios.create({
    baseURL: `${BASE_URL}/portal`,
});

apiClient.interceptors.request.use((cfg) => {
    const token = getToken();
    if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
    return cfg;
});

apiClient.interceptors.response.use(
    (response) => response,
    apiErrorHandler
);

export default apiClient;